module.exports = __webpack_public_path__ + "static/wedding-web-cover-7b3d16ecdf1a94bd6c90ce11135d4f70.gif";